import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

interface EventRequest {
    eventId: number;
    eventType: string;
    message: string;
    replyToMessageId: number
}

export interface chatMessageState {
    chatResponse: any | null;
    loading: boolean;
    error: string | null;
    success: boolean | null;
}

export const initialState: chatMessageState = {
    chatResponse: null,
    loading: false,
    error: null,
    success: false,
};


export const ReportChat = createAsyncThunk<any, any, { rejectValue: string }>(
    '/api/chats',
    async (payload, { rejectWithValue }) => {
        try {
            const axiosResponse = await axios.post<any>(`api/chats/conversation/report/${payload?.messageId}`, payload?.payload);
            return axiosResponse.data;
        } catch (error) {
            throw rejectWithValue(error.response?.data?.message || 'An error occurred');
        }
    }
);


export const chatReportSlice = createSlice({
    name: 'chatReportReducer',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(ReportChat.pending, state => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
            .addCase(ReportChat.fulfilled, (state, action) => {
                state.chatResponse = action.payload
                state.loading = false;
                state.error = null;
                state.success = true;
            })
            .addCase(ReportChat.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
                state.success = false;
            })
    },
});

export default chatReportSlice.reducer;
